"use strict";
/**
 * @name ScreenReader
 *
 * @description
 *  ScreenReader is a component that visually hides it's children while making them accessible to screen readers.
 *  This is intended to aid in times where there may not be visual elements (like an icon only button).
 *
 * @example
 *  <ScreenReader>
 *    Click Me
 *  </ScreenReader>
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    mods: PropTypes.string,
    testId: PropTypes.string,
};
var ScreenReader = function (_a) {
    var className = _a.className, mods = _a.mods, children = _a.children, testId = _a.testId;
    var cname = (0, helpers_1.getClassName)(className, mods, 'u-hiddenVisually');
    return (React.createElement("span", { className: cname, "data-testid": testId }, children));
};
ScreenReader.propTypes = propTypes;
ScreenReader.defaultProps = {
    children: null,
    className: null,
    mods: null,
    testId: null,
};
exports.default = ScreenReader;
